import React, { memo } from "react";
import {
  Accordion, Box, Divider,
  List,
  ListItem,
} from '@chakra-ui/react'
import { SidebarItemLink } from "../../molecules/SidebarItemLink";
import { ManagerName } from "../../atoms/ManagerName";


export const ManagerSidebarMenu: React.FC = memo(() => {
  return (
    <Accordion allowMultiple>
      <Divider m='0' />
      <Box px={4} py={3} fontWeight="bold" fontSize="md">
        <ManagerName />
      </Box>
      <Divider m='0' />
      <List spacing={1}>
        <ListItem >
          <SidebarItemLink to='' text="基本情報" />
        </ListItem>
        <ListItem >
          <SidebarItemLink to='restaurants' text="店舗" />
        </ListItem>
      </List>
    </Accordion>
  );
});